import { render, staticRenderFns } from "./ConfigureSettingsNew.vue?vue&type=template&id=4776e4f2&scoped=true"
import script from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
export * from "./ConfigureSettingsNew.vue?vue&type=script&lang=js"
import style0 from "./ConfigureSettingsNew.vue?vue&type=style&index=0&id=4776e4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4776e4f2",
  null
  
)

export default component.exports